import { render, staticRenderFns } from "./EditBundleDlg.vue?vue&type=template&id=5e237d21&scoped=true&"
import script from "./EditBundleDlg.vue?vue&type=script&lang=ts&"
export * from "./EditBundleDlg.vue?vue&type=script&lang=ts&"
import style0 from "./EditBundleDlg.vue?vue&type=style&index=0&id=5e237d21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e237d21",
  null
  
)

export default component.exports